import { TaskCompletion } from 'graphql-common';

export default function getCompletionMediaIds(
  answers: TaskCompletion['answers'],
): string[] {
  return (answers || []).flatMap((answer) =>
    (answer?.attachmentsAttached || [])
      .map((attachment) => attachment?.id)
      .filter((id): id is string => !!id),
  );
}
